import React from 'react'
import { BsPaletteFill } from 'react-icons/bs'
import { hobbiesWithIcons } from '../../../utilities/utilities'

function Hobbies({ match }) {

    const hobbies = hobbiesWithIcons(match?.personalDetails?.interests?.hobbies);
    return (
        <>
            <div className='d-flex'>
                <BsPaletteFill className='match-detail-icon' />
                <div className='match-detail-title'>Hobbies & Interests</div>
            </div>
            <div className='d-flex match-detail-info flex-wrap'>
                {

                    hobbies?.map((hobby, index) => {
                        return (
                            <div key={index} className='d-flex hobbie-badge'>
                                {hobby.icon} {hobby.value}
                            </div>
                        )
                    }
                    )
                }

            </div>
            <div className='match-detail-info'></div>
        </>
    )
}

export default Hobbies